import { PurposeEnum, Search } from "@/types/types";
import styles from "../page-searchbar.module.css";
import { useEffect, useRef, useState } from "react";
import { useDropdownPosition } from "@/hooks/use-dropdown-position";
import SelectorComponentListItem from "@/components/searchbars/selector-component-list-item";
import { usePageStore } from "../../../usePageStore";
import { IoIosArrowDown } from "react-icons/io";

export default function PurposeSelectorClient({
  t,
  purpose,
  refetchState,
  fullWidth,
}: {
  t: any;
  purpose: PurposeEnum;
  refetchState: () => Promise<void>;
  fullWidth?: boolean;
}) {
  const [isPurposeOpen, setIsPurposeOpen] = useState(false);
  const purposeListRef = useRef<HTMLDivElement>(null);
  const setPurpose = usePageStore((state) => state.setPurpose);
  const purposeListStyles = useDropdownPosition(purposeListRef, isPurposeOpen, {
    customWidth: 180, // px,
    fullWidth: fullWidth,
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        purposeListRef.current &&
        !purposeListRef.current.contains(event.target as Node)
      ) {
        setIsPurposeOpen(false); //this will close it
      }
    };
    if (isPurposeOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPurposeOpen]);

  return (
    <div
      className={`${styles.selectWrapper} ${styles.purposeItemWrapper} ${
        fullWidth && styles.fullWidth
      }`}
      ref={purposeListRef}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          setIsPurposeOpen(!isPurposeOpen);
        }}
        className={`${styles.pill} ${isPurposeOpen && styles.pillOpen}`}
      >
        <div className={styles.textWrapper}>
          <span>{t(purpose)}</span>
        </div>
        <span className={styles.chevron}>
          <IoIosArrowDown />
        </span>
      </button>
      {isPurposeOpen && purposeListStyles.top && (
        <ul className={`${styles.selectionList}`} style={purposeListStyles}>
          <SelectorComponentListItem
            text={t("for-sale")}
            icon={null}
            isActive={purpose === PurposeEnum.FORSALE}
            onClick={async () => {
              setPurpose(PurposeEnum.FORSALE);
              setIsPurposeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
          <SelectorComponentListItem
            text={t("for-rent")}
            icon={null}
            isActive={purpose === PurposeEnum.FORRENT}
            onClick={async () => {
              setPurpose(PurposeEnum.FORRENT);
              setIsPurposeOpen(false);
              await refetchState();
            }}
            isSearchbar={true}
          />
        </ul>
      )}
    </div>
  );
}
